var map = {
	"./ActivityLog": 44173,
	"./ActivityLog.jsx": 44173,
	"./Ad": 57955,
	"./Ad.jsx": 57955,
	"./AddSentenceToCollection": 11259,
	"./AddSentenceToCollection.jsx": 11259,
	"./AddSentenceToCollectionBtn": 65935,
	"./AddSentenceToCollectionBtn.jsx": 65935,
	"./AddSentenceToCollectionModal": 78780,
	"./AddSentenceToCollectionModal.jsx": 78780,
	"./AutoScrollablePre": 34527,
	"./AutoScrollablePre.jsx": 34527,
	"./ChatBot": 97227,
	"./ChatBot.jsx": 97227,
	"./Checkbox": 68135,
	"./Checkbox.jsx": 68135,
	"./ClozeSelectable": 46177,
	"./ClozeSelectable.jsx": 46177,
	"./ClozeSentence": 68462,
	"./ClozeSentence.jsx": 68462,
	"./ClozeSentenceSearch": 75922,
	"./ClozeSentenceSearch.jsx": 75922,
	"./ClozeSentenceSearch/BulkAdd": 49982,
	"./ClozeSentenceSearch/BulkAdd.jsx": 49982,
	"./ClozeSentenceSearch/SearchForm": 55621,
	"./ClozeSentenceSearch/SearchForm.jsx": 55621,
	"./ClozeSentenceSearch/SearchResult": 94420,
	"./ClozeSentenceSearch/SearchResult.jsx": 94420,
	"./ClozeSentenceSearchModal": 80931,
	"./ClozeSentenceSearchModal.jsx": 80931,
	"./ClozeText/ClozeTextAddToCollectionBtn": 49021,
	"./ClozeText/ClozeTextAddToCollectionBtn.jsx": 49021,
	"./ClozeText/ClozeTextSentenceSearchBtn": 36142,
	"./ClozeText/ClozeTextSentenceSearchBtn.jsx": 36142,
	"./CollectionClozeSentenceEditor": 98401,
	"./CollectionClozeSentenceEditor.jsx": 98401,
	"./CollectionClozeSentenceEditorModal": 84842,
	"./CollectionClozeSentenceEditorModal.jsx": 84842,
	"./CollectionClozeSentenceExplanation": 7481,
	"./CollectionClozeSentenceExplanation.jsx": 7481,
	"./CollectionSelector": 96991,
	"./CollectionSelector.jsx": 96991,
	"./ConjugationPractice": 90204,
	"./ConjugationPractice.jsx": 90204,
	"./CopySentencePopover": 73677,
	"./CopySentencePopover.jsx": 73677,
	"./DailyGoalModal": 64225,
	"./DailyGoalModal.jsx": 64225,
	"./DailyGoalPanel": 9032,
	"./DailyGoalPanel.jsx": 9032,
	"./DailyGoalPanelV2": 3988,
	"./DailyGoalPanelV2.jsx": 3988,
	"./DailyGoalStats": 48507,
	"./DailyGoalStats.jsx": 48507,
	"./DailyReminderBtn": 79439,
	"./DailyReminderBtn.jsx": 79439,
	"./DailyReminderModal": 53884,
	"./DailyReminderModal.jsx": 53884,
	"./DailyReminderPanel": 92697,
	"./DailyReminderPanel.jsx": 92697,
	"./Dashboard": 71506,
	"./Dashboard.jsx": 71506,
	"./Dashboard/AddClozeFromWordsToCollectionModal": 50408,
	"./Dashboard/AddClozeFromWordsToCollectionModal.jsx": 50408,
	"./Dashboard/AddFileToCollectionModal": 66820,
	"./Dashboard/AddFileToCollectionModal.jsx": 66820,
	"./Dashboard/AddTextToCollectionModal": 16657,
	"./Dashboard/AddTextToCollectionModal.jsx": 16657,
	"./Dashboard/AddToCollectionModal": 44654,
	"./Dashboard/AddToCollectionModal.jsx": 44654,
	"./Dashboard/BulkSentenceCreationEditor": 98164,
	"./Dashboard/BulkSentenceCreationEditor.jsx": 98164,
	"./Dashboard/ChallengeFriendsPanel": 79715,
	"./Dashboard/ChallengeFriendsPanel.jsx": 79715,
	"./Dashboard/ChunkProgressBar": 70550,
	"./Dashboard/ChunkProgressBar.jsx": 70550,
	"./Dashboard/ClozeListeningCollectionComponent": 64688,
	"./Dashboard/ClozeListeningCollectionComponent.jsx": 64688,
	"./Dashboard/ClozeListeningPanel": 95779,
	"./Dashboard/ClozeListeningPanel.jsx": 95779,
	"./Dashboard/CollectionEditor": 70660,
	"./Dashboard/CollectionEditor.jsx": 70660,
	"./Dashboard/CollectionEditorModal": 45133,
	"./Dashboard/CollectionEditorModal.jsx": 45133,
	"./Dashboard/CollectionGroupingsPanel": 10447,
	"./Dashboard/CollectionGroupingsPanel.jsx": 10447,
	"./Dashboard/CollectionPanel": 99689,
	"./Dashboard/CollectionPanel.jsx": 99689,
	"./Dashboard/CollectionProgressBar": 8267,
	"./Dashboard/CollectionProgressBar.jsx": 8267,
	"./Dashboard/CollectionReviewSettingsModal": 97729,
	"./Dashboard/CollectionReviewSettingsModal.jsx": 97729,
	"./Dashboard/CollectionTableRow": 90131,
	"./Dashboard/CollectionTableRow.jsx": 90131,
	"./Dashboard/CollectionsModalTable": 90721,
	"./Dashboard/CollectionsModalTable.jsx": 90721,
	"./Dashboard/Core1kCollectionComponent": 51061,
	"./Dashboard/Core1kCollectionComponent.jsx": 51061,
	"./Dashboard/DeleteLanguagePairingModal": 69367,
	"./Dashboard/DeleteLanguagePairingModal.jsx": 69367,
	"./Dashboard/DownloadFavoritesModal": 93337,
	"./Dashboard/DownloadFavoritesModal.jsx": 93337,
	"./Dashboard/FastTrackComponent": 32835,
	"./Dashboard/FastTrackComponent.jsx": 32835,
	"./Dashboard/FastTrackPanel": 42856,
	"./Dashboard/FastTrackPanel.jsx": 42856,
	"./Dashboard/FastTrackStats": 66203,
	"./Dashboard/FastTrackStats.jsx": 66203,
	"./Dashboard/FastTrackStatsModal": 95164,
	"./Dashboard/FastTrackStatsModal.jsx": 95164,
	"./Dashboard/FastTrackV2Panel": 24868,
	"./Dashboard/FastTrackV2Panel.jsx": 24868,
	"./Dashboard/FavoritesModal": 51913,
	"./Dashboard/FavoritesModal.jsx": 51913,
	"./Dashboard/FollowClozemasterPanel": 51813,
	"./Dashboard/FollowClozemasterPanel.jsx": 51813,
	"./Dashboard/FrequencyCollectionsComponent": 75445,
	"./Dashboard/FrequencyCollectionsComponent.jsx": 75445,
	"./Dashboard/FullHistoryBtn": 71816,
	"./Dashboard/FullHistoryBtn.jsx": 71816,
	"./Dashboard/FullHistoryBtnV2": 44372,
	"./Dashboard/FullHistoryBtnV2.jsx": 44372,
	"./Dashboard/GoogleAdPanel": 33211,
	"./Dashboard/GoogleAdPanel.jsx": 33211,
	"./Dashboard/GooglePanelsAd": 94812,
	"./Dashboard/GooglePanelsAd.jsx": 94812,
	"./Dashboard/GoogleRightSidebarAd": 93719,
	"./Dashboard/GoogleRightSidebarAd.jsx": 93719,
	"./Dashboard/GrammarCollectionsComponent": 39576,
	"./Dashboard/GrammarCollectionsComponent.jsx": 39576,
	"./Dashboard/LanguagePairingSettingsModal": 50227,
	"./Dashboard/LanguagePairingSettingsModal.jsx": 50227,
	"./Dashboard/LanguagePairingSettingsModalV2": 25499,
	"./Dashboard/LanguagePairingSettingsModalV2.jsx": 25499,
	"./Dashboard/LeaderboardModal": 16279,
	"./Dashboard/LeaderboardModal.jsx": 16279,
	"./Dashboard/LeaderboardStatPanel": 5440,
	"./Dashboard/LeaderboardStatPanel.jsx": 5440,
	"./Dashboard/MoreStatsModal": 14296,
	"./Dashboard/MoreStatsModal.jsx": 14296,
	"./Dashboard/MyCollectionsPanel": 82994,
	"./Dashboard/MyCollectionsPanel.jsx": 82994,
	"./Dashboard/RandomCollectionComponent": 44893,
	"./Dashboard/RandomCollectionComponent.jsx": 44893,
	"./Dashboard/RankingsModal": 55047,
	"./Dashboard/RankingsModal.jsx": 55047,
	"./Dashboard/ResetProgressModal": 92024,
	"./Dashboard/ResetProgressModal.jsx": 92024,
	"./Dashboard/ReviewBtnPanel": 10485,
	"./Dashboard/ReviewBtnPanel.jsx": 10485,
	"./Dashboard/ReviewSettings": 74096,
	"./Dashboard/ReviewSettings.jsx": 74096,
	"./Dashboard/ReviewSettingsModal": 91313,
	"./Dashboard/ReviewSettingsModal.jsx": 91313,
	"./Dashboard/ReviewStatPanel": 51319,
	"./Dashboard/ReviewStatPanel.jsx": 51319,
	"./Dashboard/SharedCollection": 79800,
	"./Dashboard/SharedCollection.jsx": 79800,
	"./Dashboard/SharedCollectionsModal": 28358,
	"./Dashboard/SharedCollectionsModal.jsx": 28358,
	"./Dashboard/StatPanel": 95503,
	"./Dashboard/StatPanel.jsx": 95503,
	"./Dashboard/V3ClozeListeningPanel": 48616,
	"./Dashboard/V3ClozeListeningPanel.jsx": 48616,
	"./Dashboard/V3DailyGoalPanel": 16898,
	"./Dashboard/V3DailyGoalPanel.jsx": 16898,
	"./Dashboard/V3LeaderboardPanel": 22267,
	"./Dashboard/V3LeaderboardPanel.jsx": 22267,
	"./Dashboard/V3ReviewPanel": 68738,
	"./Dashboard/V3ReviewPanel.jsx": 68738,
	"./Dashboard/V3ReviewSettings": 92285,
	"./Dashboard/V3ReviewSettings.jsx": 92285,
	"./Dashboard/V3ReviewSettingsModal": 78174,
	"./Dashboard/V3ReviewSettingsModal.jsx": 78174,
	"./Dashboard/V3StreakPanel": 14228,
	"./Dashboard/V3StreakPanel.jsx": 14228,
	"./Dashboard/redux/reducers": 34268,
	"./Dashboard/redux/reducers/": 34268,
	"./Dashboard/redux/reducers/actionTypes": 35231,
	"./Dashboard/redux/reducers/actionTypes.js": 35231,
	"./Dashboard/redux/reducers/collections": 26797,
	"./Dashboard/redux/reducers/collections.js": 26797,
	"./Dashboard/redux/reducers/index": 34268,
	"./Dashboard/redux/reducers/index.js": 34268,
	"./Dashboard/redux/store": 96225,
	"./Dashboard/redux/store.js": 96225,
	"./DashboardV2-FAILED": 32734,
	"./DashboardV2-FAILED.jsx": 32734,
	"./DashboardV3": 58179,
	"./DashboardV3.jsx": 58179,
	"./DiscussionBtn": 17162,
	"./DiscussionBtn.jsx": 17162,
	"./ExplanationRequest": 15584,
	"./ExplanationRequest.jsx": 15584,
	"./FadeIn": 61291,
	"./FadeIn.jsx": 61291,
	"./FadeOut": 36460,
	"./FadeOut.jsx": 36460,
	"./FeedbackWidget": 64129,
	"./FeedbackWidget.jsx": 64129,
	"./FlagSprite": 28737,
	"./FlagSprite.jsx": 28737,
	"./Icon": 40727,
	"./Icon.jsx": 40727,
	"./LanguagePairingOrder": 19150,
	"./LanguagePairingOrder.jsx": 19150,
	"./LanguagePairings": 32793,
	"./LanguagePairings.jsx": 32793,
	"./Loading": 73898,
	"./Loading.jsx": 73898,
	"./LoadingOverlay": 74904,
	"./LoadingOverlay.jsx": 74904,
	"./ManageCollectionModal": 94870,
	"./ManageCollectionModal.jsx": 94870,
	"./ManageCollectionModal/CollectionClozeSentence": 20911,
	"./ManageCollectionModal/CollectionClozeSentence.jsx": 20911,
	"./ManageCollectionModal/CollectionClozeSentenceEditableAttribute": 755,
	"./ManageCollectionModal/CollectionClozeSentenceEditableAttribute.jsx": 755,
	"./Markdown": 29419,
	"./Markdown.jsx": 29419,
	"./MarkedAsKnownIcon": 28852,
	"./MarkedAsKnownIcon.jsx": 28852,
	"./MasteredIcon": 9830,
	"./MasteredIcon.jsx": 9830,
	"./MaxPlayedTodayModal": 89726,
	"./MaxPlayedTodayModal.jsx": 89726,
	"./Modal": 40897,
	"./Modal.jsx": 40897,
	"./ModalControl": 3158,
	"./ModalControl.jsx": 3158,
	"./ModalFooterCloseBtn": 508,
	"./ModalFooterCloseBtn.jsx": 508,
	"./ModalProPromo": 61703,
	"./ModalProPromo.jsx": 61703,
	"./NewCollectionForm": 73294,
	"./NewCollectionForm.jsx": 73294,
	"./Onboarding": 52143,
	"./Onboarding.jsx": 52143,
	"./OnboardingWelcome": 90075,
	"./OnboardingWelcome.jsx": 90075,
	"./PaddleCheckout": 55628,
	"./PaddleCheckout.jsx": 55628,
	"./Pagination": 86956,
	"./Pagination.jsx": 86956,
	"./Panel": 18152,
	"./Panel.jsx": 18152,
	"./PlayClozeListening": 80000,
	"./PlayClozeListening.jsx": 80000,
	"./PlayClozeListening/ReportModal": 42100,
	"./PlayClozeListening/ReportModal.jsx": 42100,
	"./PlayCollection": 83394,
	"./PlayCollection.jsx": 83394,
	"./PlayCollection/AccentButtons": 94626,
	"./PlayCollection/AccentButtons.jsx": 94626,
	"./PlayCollection/DiscussionModal": 50964,
	"./PlayCollection/DiscussionModal.jsx": 50964,
	"./PlayCollection/GameSettings": 43302,
	"./PlayCollection/GameSettings.jsx": 43302,
	"./PlayCollection/HelpModal": 45895,
	"./PlayCollection/HelpModal.jsx": 45895,
	"./PlayCollection/Hint": 80240,
	"./PlayCollection/Hint.jsx": 80240,
	"./PlayCollection/Incorrect": 52226,
	"./PlayCollection/Incorrect.jsx": 52226,
	"./PlayCollection/IntraRoundAd": 66148,
	"./PlayCollection/IntraRoundAd.jsx": 66148,
	"./PlayCollection/LeveledUpModal": 88622,
	"./PlayCollection/LeveledUpModal.jsx": 88622,
	"./PlayCollection/ListeningControl": 33405,
	"./PlayCollection/ListeningControl.jsx": 33405,
	"./PlayCollection/MultipleChoiceOptions": 19782,
	"./PlayCollection/MultipleChoiceOptions.jsx": 19782,
	"./PlayCollection/Points": 60846,
	"./PlayCollection/Points.jsx": 60846,
	"./PlayCollection/ReportErrorBtn": 93491,
	"./PlayCollection/ReportErrorBtn.jsx": 93491,
	"./PlayCollection/ReportErrorModal": 13104,
	"./PlayCollection/ReportErrorModal.jsx": 13104,
	"./PlayCollection/RoundHistoryModal": 85964,
	"./PlayCollection/RoundHistoryModal.jsx": 85964,
	"./PlayCollection/RoundResults": 89025,
	"./PlayCollection/RoundResults.jsx": 89025,
	"./PlayCollection/ShortcutsList": 23314,
	"./PlayCollection/ShortcutsList.jsx": 23314,
	"./PlayCollection/TeachingCollectionResultsForm": 11088,
	"./PlayCollection/TeachingCollectionResultsForm.jsx": 11088,
	"./PlayCollection/TextToSpeechSettings": 75148,
	"./PlayCollection/TextToSpeechSettings.jsx": 75148,
	"./PlayCollection/Tokens": 74885,
	"./PlayCollection/Tokens.jsx": 74885,
	"./PlayCollectionV2": 63014,
	"./PlayCollectionV2.jsx": 63014,
	"./PlayOptionsModal": 64639,
	"./PlayOptionsModal.jsx": 64639,
	"./PlaySystemTtsButton": 46402,
	"./PlaySystemTtsButton.jsx": 46402,
	"./PlayingIcon": 50715,
	"./PlayingIcon.jsx": 50715,
	"./ProgressBar": 20126,
	"./ProgressBar.jsx": 20126,
	"./PublicRadio": 31842,
	"./PublicRadio.jsx": 31842,
	"./Radio": 28499,
	"./Radio.jsx": 28499,
	"./Rankings": 89977,
	"./Rankings.jsx": 89977,
	"./ReportedCollectionClozeSentences": 79585,
	"./ReportedCollectionClozeSentences/": 79585,
	"./ReportedCollectionClozeSentences/index": 79585,
	"./ReportedCollectionClozeSentences/index.js": 79585,
	"./ResourceLinks": 4349,
	"./ResourceLinks.jsx": 4349,
	"./SaleCountdownTimer": 70485,
	"./SaleCountdownTimer.jsx": 70485,
	"./SelectionPopover": 72717,
	"./SelectionPopover.jsx": 72717,
	"./SelectionPopoverableLink": 50933,
	"./SelectionPopoverableLink.jsx": 50933,
	"./SelectionSlideout": 92313,
	"./SelectionSlideout.jsx": 92313,
	"./SelectionToken": 27025,
	"./SelectionToken.jsx": 27025,
	"./SelectionTokenText": 58896,
	"./SelectionTokenText.jsx": 58896,
	"./SlideDown": 20997,
	"./SlideDown.jsx": 20997,
	"./Slideout": 18173,
	"./Slideout.jsx": 18173,
	"./SpeechSynthesisBtn": 69204,
	"./SpeechSynthesisBtn.jsx": 69204,
	"./SpeechToText": 46752,
	"./SpeechToText.jsx": 46752,
	"./Strike": 90350,
	"./Strike.jsx": 90350,
	"./TeachingDashboard": 41305,
	"./TeachingDashboard.jsx": 41305,
	"./TeachingDashboard/ClozeSentenceSearch": 75404,
	"./TeachingDashboard/ClozeSentenceSearch.jsx": 75404,
	"./TeachingDashboard/Contributors": 6996,
	"./TeachingDashboard/Contributors.jsx": 6996,
	"./TeachingDashboard/CrosswordViewer": 30854,
	"./TeachingDashboard/CrosswordViewer.jsx": 30854,
	"./TeachingDashboard/EmbedBuilder": 87394,
	"./TeachingDashboard/EmbedBuilder.jsx": 87394,
	"./TeachingDashboard/LinkBuilder": 68989,
	"./TeachingDashboard/LinkBuilder.jsx": 68989,
	"./TeachingDashboard/MyTeachingCollection": 3917,
	"./TeachingDashboard/MyTeachingCollection.jsx": 3917,
	"./TeachingDashboard/ResultsViewer": 39384,
	"./TeachingDashboard/ResultsViewer.jsx": 39384,
	"./TeachingDashboard/SentencesEditor": 49081,
	"./TeachingDashboard/SentencesEditor.jsx": 49081,
	"./Toast": 24367,
	"./Toast.jsx": 24367,
	"./UserProfileAttr": 39359,
	"./UserProfileAttr.jsx": 39359,
	"./WorksheetEditor": 9324,
	"./WorksheetEditor/": 9324,
	"./WorksheetEditor/Block": 65851,
	"./WorksheetEditor/Block.jsx": 65851,
	"./WorksheetEditor/SentenceBlock": 81670,
	"./WorksheetEditor/SentenceBlock.jsx": 81670,
	"./WorksheetEditor/SentenceEditor": 66630,
	"./WorksheetEditor/SentenceEditor.jsx": 66630,
	"./WorksheetEditor/SentenceSearchModal": 2986,
	"./WorksheetEditor/SentenceSearchModal.jsx": 2986,
	"./WorksheetEditor/SentenceSearchResult": 26890,
	"./WorksheetEditor/SentenceSearchResult.jsx": 26890,
	"./WorksheetEditor/SentencesBlock": 65979,
	"./WorksheetEditor/SentencesBlock.jsx": 65979,
	"./WorksheetEditor/TextBlock": 51100,
	"./WorksheetEditor/TextBlock.jsx": 51100,
	"./WorksheetEditor/index": 9324,
	"./WorksheetEditor/index.jsx": 9324,
	"./admin/BlogPostLanguagePairing": 13942,
	"./admin/BlogPostLanguagePairing.jsx": 13942,
	"./admin/ClozeSentenceSearch/SearchForm": 33009,
	"./admin/ClozeSentenceSearch/SearchForm.jsx": 33009,
	"./admin/CollectionClozeSentenceRow": 20000,
	"./admin/CollectionClozeSentenceRow.jsx": 20000,
	"./admin/CollectionClozeSentences": 1503,
	"./admin/CollectionClozeSentences.jsx": 1503,
	"./admin/CommonVoiceSentenceTr": 56744,
	"./admin/CommonVoiceSentenceTr.jsx": 56744,
	"./admin/QuickMod": 30579,
	"./admin/QuickMod.jsx": 30579,
	"./admin/QuickMod/Tokens": 28878,
	"./admin/QuickMod/Tokens.jsx": 28878,
	"./admin/StatsReportsLineChart": 76994,
	"./admin/StatsReportsLineChart.jsx": 76994,
	"./admin/TTSVoicesTable": 37574,
	"./admin/TTSVoicesTable.jsx": 37574,
	"./admin/TTSVoicesTableRow": 64100,
	"./admin/TTSVoicesTableRow.jsx": 64100,
	"./admin/Words": 18157,
	"./admin/Words.jsx": 18157,
	"./admin/Words/Word": 28906,
	"./admin/Words/Word.jsx": 28906,
	"./mods/ClozeSentenceEditor": 94513,
	"./mods/ClozeSentenceEditor.jsx": 94513,
	"./mods/ClozeSentenceEntry": 36052,
	"./mods/ClozeSentenceEntry.jsx": 36052,
	"./mods/ClozeSentenceTts": 60011,
	"./mods/ClozeSentenceTts.jsx": 60011,
	"./mods/CollectionClozeSentenceChange": 21270,
	"./mods/CollectionClozeSentenceChange.jsx": 21270,
	"./mods/CollectionClozeSentenceChangesModal": 1988,
	"./mods/CollectionClozeSentenceChangesModal.jsx": 1988,
	"./mods/CollectionClozeSentenceEditor": 10065,
	"./mods/CollectionClozeSentenceEditor.jsx": 10065,
	"./mods/CollectionClozeSentenceTts": 83915,
	"./mods/CollectionClozeSentenceTts.jsx": 83915,
	"./mods/TokensEditor": 57297,
	"./mods/TokensEditor.jsx": 57297,
	"./mods/TokensEditorToken": 19622,
	"./mods/TokensEditorToken.jsx": 19622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86900;